import { Button, IconButton, Link, Stack, Typography, useTheme } from '@mui/material';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import { useHeaderContext } from '../contexts/HeaderContext';
import { getSubRoutesFromUrl } from '../routes';
import { useLocation } from 'react-router-dom';
import { ProgressButton } from '@enroller/admissions-components';
import { ValidationType } from '../contexts/HeaderContext';
import { useApplicationContext } from '../contexts/ApplicationContext/ApplicationContext';

export const Header = () => {
  const { headerTitle, triggerSubmit, isFormLoading } = useHeaderContext();
  const { pathname } = useLocation();
  const { applicationProgress } = useApplicationContext();
  const totalProgress = applicationProgress ? applicationProgress.progress : 0;
  const theme = useTheme();

  const routes = getSubRoutesFromUrl(pathname);

  if (!routes?.subRoutes) return;

  const currentProcessRoutes = routes.subRoutes.flatMap((subRoute) => Object.values(subRoute.routes));
  const currentStep = currentProcessRoutes.find((route) => route.url === pathname.split('/')[2]);
  const previousPage = currentProcessRoutes.find((route) => currentStep && route.order === currentStep?.order - 1);
  const nextPage = currentProcessRoutes.find((route) => currentStep && route.order === currentStep?.order + 1);
  const previousPageUrl = `/${routes?.url}/${previousPage?.url}`;
  const nextPageUrl = `/${routes?.url}/${nextPage?.url}`;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" height="100%" px={4}>
      {headerTitle && (
        <Stack>
          <Typography color="textPrimary">{headerTitle.title}</Typography>
          <Typography variant="body2" color="textPrimary">
            {headerTitle.subtitle}
          </Typography>
        </Stack>
      )}
      <Stack direction="row" spacing={2}>
        <IconButton disabled={!previousPage} component={Link} href={previousPageUrl} color="secondary" sx={theme.mixins.roundedIconButton}>
          <ArrowBackOutlinedIcon />
        </IconButton>

        <IconButton disabled={!nextPage} component={Link} href={nextPageUrl} color="secondary" sx={theme.mixins.roundedIconButton}>
          <ArrowForwardOutlinedIcon />
        </IconButton>
        <Button variant="outlined" color="primary" loading={isFormLoading} onClick={() => triggerSubmit(ValidationType.Draft)}>
          Save draft
        </Button>
        <ProgressButton
          onClick={() => triggerSubmit(ValidationType.Full)}
          progress={totalProgress}
          tooltipText="Complete all fields to be able to submit. Click to highlight incomplete fields"
        />
        {/* TODO: re-enable invite student button once logic for the button has been implemented */}
        {/* <Button variant="outlined" color="secondary" loading={isFormLoading} onClick={() => console.log('Invite student')}>
          Invite Student
        </Button> */}
      </Stack>
    </Stack>
  );
};
